
import ClaimUnclaimCME from '../common/ClaimUnclaimCME'
 

export default function UnclaimedCMEDashboard(props:any){
  return(
    <ClaimUnclaimCME source='Unclaimed'/>
  )

}